import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import dateformat from 'dateformat'
import API from '../../api'
import Pagination from '../common/Pagination'

class ListEventsPage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      events: [],
      count: 0,
      countPages: 0
    }
    this.loadingEvents = this.loadingEvents.bind(this)
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this)
  }

  componentDidMount () {
    let page = (this.props.match.params.page) ? parseInt(this.props.match.params.page, 10) : 1
    this.loadingEvents(page)
  }

  loadingEvents (page) {
    API.fetchAllEvents(page)
      .then(data => this.setState({
        events: data.data.result,
        count: data.data.count,
        countPages: data.data.pages,
        page
      }))
  }

  componentWillReceiveProps (nextProps) {
    if (this.state.page !== nextProps.match.params.page) {
      let page = parseInt(nextProps.match.params.page, 10)
      page = (page) || 1
      this.loadingEvents(page)
    }
  }

  render () {
    return (
      <div className='container'>
        <h1>Events</h1>
        <div className='table-responsive-lg'>
          <table className='table table-hover'>
            <thead>
              <tr>
                <th style={{width: '40%'}}>Event</th>
                <th style={{width: '30%'}}>Date</th>
                <th style={{width: '30%'}} />
              </tr>
            </thead>
            <tbody>
              {this.state.events.map(e =>
                <tr key={e.slug}>
                  <td><Link to={'/' + e.slug} >{e.name}</Link></td>
                  <td>{dateformat(e.startDate, 'yyyy-mm-dd HH:MM')}</td>
                  <td />
                </tr>)
              }
            </tbody>
          </table>
          <Pagination
            page={this.state.page}
            countPages={this.state.countPages}
            url='/page/'
          />
        </div>
      </div>
    )
  }
}

export default ListEventsPage
